import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  saveUserRates,
  saveJobLocation,
  savePersonalData,
  saveContractType,
  saveWorkHistory,
  createNewWorkHistory
} from '../../../../actions/user';
import PersonalDetails from '../components/PersonalDetails/PersonalDetails';
import { JobDetails } from '../components/JobDetails/JobDetails';
import { JobPreferences } from '../components/JobPreferences/JobPreferences';
import { TermsWrapper } from '../components/Terms/TermsWrapper';
import ProfileWrapper from '../components/ProfileWrapper/ProfileWrapper';
import { setNotification } from '../../../../actions/appNotifications';
import { appNotificationsTypes } from '../../../../utils/constants';

function Profile() {
  const userId = localStorage.getItem('UserId');

  const profile = useSelector((state) => state.user.profile);
  const profileError = useSelector((state) => state.user.error);
  const profilePending = useSelector((state) => state.user.pendingFlag);
  const updatingError = useSelector((state) => state.user.updatingError);
  const updatingPending = useSelector((state) => state.user.updatingPending);

  const personalData = {
    SecondaryEmail: profile?.SecondaryEmail,
    Phone: profile?.Phone,
    PhoneCountryCode: profile?.PhoneCountryCode,
    PhoneType: profile?.PhoneType,
    City: profile?.City,
    State: profile?.State,
    Country: profile?.Country,
    AddressLine1: profile?.AddressLine1,
    AddressLine2: profile?.AddressLine2,
    ZipCode: profile?.ZipCode
  };
  const userRates = useSelector((state) => state.user.profile?.UserRates[0]);
  const jobLocation = {
    OpenToRelocation: profile?.OpenToRelocation,
    OpentoRemoteWork: profile?.OpentoRemoteWork
  };
  const dispatch = useDispatch();

  const updateContractType = (data) => {
    dispatch(saveContractType(userId, { ...data }));
  };

  const updateUserRates = (data) => {
    dispatch(saveUserRates(userId, { ...userRates, ...data }));
  };

  const updatePersonalData = (data) => {
    dispatch(savePersonalData(userId, { ...personalData, ...data }));
  };

  const updateJobLocation = (data) => {
    dispatch(saveJobLocation(userId, { ...data }));
  };

  const updateworkHistory = (data) => {
    dispatch(saveWorkHistory(data?.Id, { ...data, CurrentlyWorkThere: true }));
  };

  const createWorkHistory = (data) => {
    dispatch(createNewWorkHistory(data));
  };

  useEffect(() => {
    if (updatingError)
      dispatch(
        setNotification({
          type: appNotificationsTypes.ERROR,
          message: updatingError,
          duration: 3000
        })
      );
  }, [updatingError]);

  return (
    <ProfileWrapper profile={profile} error={profileError} pending={profilePending} prof userId={userId}>
      <PersonalDetails userData={profile} updateUserData={updatePersonalData} updating={updatingPending} />
      <br />
      <JobDetails
        jobData={profile?.WorkHistories}
        updateworkHistory={updateworkHistory}
        createWorkHistory={createWorkHistory}
        updating={updatingPending}
      />
      <JobPreferences
        profile={profile}
        jobLocation={jobLocation}
        updateJobLocation={updateJobLocation}
        updateContractType={updateContractType}
        updating={updatingPending}
      />
      <TermsWrapper userRates={userRates} updateUserRates={updateUserRates} updating={updatingPending} />
    </ProfileWrapper>
  );
}

export default Profile;
